import { useCallback, useRef } from "react";

import useAwaitVerificationVerdict from "./useAwaitVerificationVerdict";

export default function useSaveWithVerdict({
  autocomplete,
  isDirty,
  values,
  onSave,
}) {
  const awaitVerdict = useAwaitVerificationVerdict(autocomplete);

  const isDirtyRef = useRef(isDirty);
  const valuesRef = useRef(values);
  const onSaveRef = useRef(onSave);
  isDirtyRef.current = isDirty;
  valuesRef.current = values;
  onSaveRef.current = onSave;

  return useCallback(async () => {
    if (isDirtyRef.current) await awaitVerdict();
    return onSaveRef.current(valuesRef.current);
  }, [awaitVerdict]);
}
